import { useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { Button, Modal, ModalBody } from "reactstrap";
import { Href, NoInternetTitle, Reconnect } from "../../../../Constants/Constants";
import { dynamicImage, Image } from "../../../../Utils";

const NoInternet = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Fragment>
      <Button color="primary" className="fonts font_label" onClick={toggle}>{NoInternetTitle}</Button>
      <Modal isOpen={modal} fade toggle={toggle} centered>
        <ModalBody className="p-0">
          <div className="no-internet animat-rate">
            <div className="connection-img">
              <Image className="left-img" src={dynamicImage("disconnect/3.png")} alt="Disconnected" />
              <Image className="right-img" src={dynamicImage("disconnect/2.png")} alt="Disconnected internet" />
            </div>
            <div className="quarterCircle">
              <div className="close-btn" onClick={toggle}>
                <span>×</span>
              </div>
            </div>
            <div className="bg_circle"><div /><div /><div /><div /><div /></div>
            <div className="cross" />
            <div className="cross1" />
            <div className="dot" />
            <div className="dot1" />
            <div className="content text-center">
              <a className="icon-btn btn-danger button-effect btn-sm is-animating" href={Href} onClick={toggle}><i className="fa fa-wifi" /></a>
              <h5>Internet issue</h5>
              <div className="title2">Disconnected</div>
              <Button className="reconnect-btn" onClick={toggle}>{Reconnect}</Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default NoInternet;
